import { render, staticRenderFns } from "./CarrierEdit.vue?vue&type=template&id=02934535&"
import script from "./CarrierEdit.vue?vue&type=script&lang=js&"
export * from "./CarrierEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports